import '@inovua/reactdatagrid-community/index.css';
import React from 'react';
// import {useHistory} from 'react-router-dom';
import { inject } from 'mobx-react';

import { Table, Column, HeaderCell, Cell} from 'rsuite-table';
import 'rsuite-table/dist/css/rsuite-table.css';

const baseTableProps = {
    height: 400,
};

const baseStyles = {
    zIndex: 0,
}

const isSelected = (selectedItems = [], rowData) => selectedItems.some(selected => selected === (rowData.id || rowData._id));

export const SelectorGrid = ({dataSource, gridType, onSelectItem, selectedItems}) => {
    switch(gridType) {
        case "SONG":
        case "SONGS":
            return <SongSelectorGrid dataSource={dataSource} selectedItems={selectedItems} onRowClick={onSelectItem}/>
        case "ARTIST":
        case "FEATURED":
            return <ArtistSelectorGrid dataSource={dataSource} selectedItems={selectedItems} onRowClick={onSelectItem}/>
        case "ALBUM":
        case "ALBUMS":
            return <AlbumSelectorGrid dataSource={dataSource} selectedItems={selectedItems} onRowClick={onSelectItem}/>
        default:
            return <p>Invalid List Type</p>
    }
}

const SongSelectorGrid = ({dataSource, selectedItems, onRowClick}) => {
    return (
     <Table data={dataSource} {...baseTableProps} style={baseStyles} onRowClick={onRowClick}>
            <Column width={60} fixed>
                <HeaderCell />
                <Cell>{rowData => (
                    <input
                        type="checkbox"
                        checked={isSelected(selectedItems, rowData)}
                        onChange={event => {
                            event.stopPropagation();
                            onRowClick(rowData);
                        }}
                        style={{ marginLeft: 10 }}
                    />
                )}</Cell>
            </Column>
            <Column width={250} fixed sortable resizable>
                <HeaderCell>Song Title</HeaderCell>
                <Cell>{rowData => rowData.title}</Cell>
            </Column>
            <Column width={250} fixed sortable resizable>
                <HeaderCell>Artist</HeaderCell>
                <Cell>{rowData => rowData.artistID}</Cell>
            </Column>
            <Column width={250} fixed sortable resizable>
                <HeaderCell>Additional Artists</HeaderCell>
                <Cell>{rowData => rowData.additionalArtists}</Cell>
            </Column>
            <Column width={250} fixed sortable resizable>
                <HeaderCell>Duration</HeaderCell>
                <Cell>{rowData => rowData.duration}</Cell>
            </Column>
        </Table>
    )
}
const ArtistSelectorGrid = ({dataSource, onRowClick, selectedItems}) => {
    return (
     <Table data={dataSource} {...baseTableProps} style={baseStyles} onRowClick={onRowClick}>
            <Column width={60} fixed>
                <HeaderCell />
                <Cell>{rowData => (
                    <input
                        type="checkbox"
                        checked={isSelected(selectedItems, rowData)}
                        onChange={event => {
                            event.stopPropagation();
                            onRowClick(rowData);
                        }}
                        style={{ marginLeft: 10 }}
                    />
                )}</Cell>
            </Column>
            <Column width={300} fixed sortable resizable>
                <HeaderCell>Artist Name</HeaderCell>
                <Cell dataKey='name'/>
            </Column>
            <Column width={100} fixed sortable resizable>
                <HeaderCell>Catalog Size</HeaderCell>
                <Cell>{rowData => rowData.songs?.length || 0}</Cell>
            </Column>
            <Column width={100} fixed sortable resizable>
                <HeaderCell>Join Date</HeaderCell>
                <Cell>{rowData => rowData.tier}</Cell>
            </Column>
            <Column width={100} fixed sortable resizable>
                <HeaderCell>Status</HeaderCell>
                <Cell>{rowData => rowData.status}</Cell>
            </Column>
        </Table>
    )
}
const AlbumSelectorGrid = ({dataSource, onRowClick, selectedItems}) => {
    return (
     <Table data={dataSource} {...baseTableProps} style={baseStyles} onRowClick={onRowClick}>
            <Column width={60} fixed>
                <HeaderCell />
                <Cell>{rowData => (
                    <input
                        type="checkbox"
                        checked={isSelected(selectedItems, rowData)}
                        onChange={event => {
                            event.stopPropagation();
                            onRowClick(rowData);
                        }}
                        style={{ marginLeft: 10 }}
                    />
                )}</Cell>
            </Column>
            <Column width={100} fixed sortable resizable>
                <HeaderCell>Song Title</HeaderCell>
                <Cell dataKey='title'/>
            </Column>
            <Column width={100} fixed sortable resizable>
                <HeaderCell>Artist</HeaderCell>
                <Cell dataKey='artist'/>
            </Column>
            <Column width={100} fixed sortable resizable>
                <HeaderCell>Additional Artists</HeaderCell>
                <Cell dataKey='additionalArtists'/>
            </Column>
            <Column width={100} fixed sortable resizable>
                <HeaderCell>Duration</HeaderCell>
                <Cell dataKey='duration'/>
            </Column>
        </Table>
    )
}
